const {
    Record
} = require('immutable')

export default Record({
    isFetching: false,
    error: null
})